module.exports = __webpack_public_path__ + "assets/logo-dark.png";


//////////////////
// WEBPACK FOOTER
// ./~/@abosol/theme/src/images/logo-dark.png
// module id = 350
// module chunks = 1